import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
        },
        title: "__confirm_information__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                placeholder: '',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                attrs: {
                    maxlength: 50,
                    class: 'text-uppercase'
                },
            },
            {
                label: '__last_name__',
                name: 'last_name',
                placeholder: '',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                attrs: {
                    maxlength: 50,
                    class: 'text-uppercase'
                }
            },
            {
                label: '__dob__',
                name: 'dob',
                placeholder: null,
                as: 'input',
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                attrs: {
                    maxlength: 10
                },
            },
            {
                label: '__phone__',
                name: 'phone_number',
                placeholder: '',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                attrs: {
                    maxlength: 10
                },
                hideIfCondition: (app) => {
                    // hide if sms is enforced as it would be already verified before creating an account
                    return !!app.forcePhoneVerification;
                }
            },
            {
                label: '__sin_optional__',
                name: 'sin',
                placeholder: '',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'sin',
                attrs: {
                    maxlength: 9
                },
                hideWhenReadOnly: true,
            },
            {
                addressLabel: '__your_address__',
                name: 'address',
                placeholder: '',
                as: 'input',
                type: 'fulladdress',
                value: null,
                // validationRules: 'required',
            }
        ],
        isStepReadOnly: true,
        isStepEditable: true,
    },
];

export default steps;
